/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Compare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Compare"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M4 18a1 1 0 1 1 0-2h13.586l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4-.076.068a1 1 0 0 1-1.406-1.406l.068-.076L17.586 18zM20 8H6.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4-.066-.073a1 1 0 0 1 .066-1.341l4-4 .076-.068A1 1 0 0 1 8.775 3.63l-.068.076L6.414 6H20a1 1 0 1 1 0 2"
      className="SVG"
    />
  </svg>
);

export const CompareIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'compare-icon'}
      icon={Compare}
      {...props}
      size={size}
    />
  );
};
